import React from 'react';
import Calculator from 'evcharging/containers/ev-calculator/Calculator';
import Card from 'evcharging/components/Card';

const CalculatorCard = () => {
  return (
    <Card maxWidth={1255}>
      <Calculator />
    </Card>
  );
};

export default CalculatorCard;
